import React from "react"
import { LayoutContextProvider } from "./LayoutContext.jsx"

export const CombinedContext = ({ children }) => {
  return <LayoutContextProvider>{children}</LayoutContextProvider>
}
